document.addEventListener('DOMContentLoaded', function() {
    let currentImageSlide = 0;
    const imageContainer = document.getElementById('imageCarouselContainer');
    const imageProgressBar = document.getElementById('imagePaginationProgress');
    const leftArrow = document.getElementById('leftArrow');
    const rightArrow = document.getElementById('rightArrow');

    if (!imageContainer || !imageProgressBar) return;

    function scrollImageCarousel(direction) {
        const maxSlides = imageContainer.children.length - 1;
        
        if (direction === 'left' && currentImageSlide > 0) {
            currentImageSlide--;
        } else if (direction === 'right' && currentImageSlide < maxSlides) {
            currentImageSlide++;
        }

        // Since each image takes 33.333% of the container width, we translate by percentage
        const translateX = currentImageSlide * 33.333;
        imageContainer.style.transform = `translateX(-${translateX}%)`;
        updateImagePagination();
        updateArrowStates();
    }

    function updateImagePagination() {
        const maxSlides = imageContainer.children.length - 1;
        const progress = maxSlides > 0 ? (currentImageSlide / maxSlides) * 66.67 : 0;
        imageProgressBar.style.left = `${progress}%`;
    }

    function updateArrowStates() {
        const maxSlides = imageContainer.children.length - 1;
        
        // Update left arrow
        if (currentImageSlide <= 0) {
            leftArrow.style.opacity = '0.5';
            leftArrow.style.cursor = 'not-allowed';
        } else {
            leftArrow.style.opacity = '1';
            leftArrow.style.cursor = 'pointer';
        }
        
        // Update right arrow
        if (currentImageSlide >= maxSlides) {
            rightArrow.style.opacity = '0.5';
            rightArrow.style.cursor = 'not-allowed';
        } else {
            rightArrow.style.opacity = '1';
            rightArrow.style.cursor = 'pointer';
        }
    }

    // Add event listeners
    leftArrow.addEventListener('click', function() {
        if (currentImageSlide > 0) {
            scrollImageCarousel('left');
        }
    });

    rightArrow.addEventListener('click', function() {
        const maxSlides = imageContainer.children.length - 1;
        if (currentImageSlide < maxSlides) {
            scrollImageCarousel('right');
        }
    });

    // Handle window resize to maintain correct positioning
    window.addEventListener('resize', function() {
        const translateX = currentImageSlide * 33.333;
        imageContainer.style.transform = `translateX(-${translateX}%)`;
    });

    // Initialize
    updateArrowStates();
    updateImagePagination();
});
